module.exports = __webpack_public_path__ + "img/file-chart-column.a9879aac.svg";